import React, { Component } from 'react'
import axios from '../../axios'
import format from 'format-number'
import FormDropdown from '../../components/FormDropdown'
import { status_penagihan } from '../../constants/penagihan'
import { NavLink } from 'react-router-dom'
import CardSaldo from '../../components/CardSaldo'
import qs from 'qs'
import Paging from '../../components/Paging'
import Alert from 'react-s-alert'
import DatePicker from 'react-datepicker'
import { dateIndo } from '../../functions/functionGeneral'

class Lists extends Component {

    constructor() {
        super();
        this.state = {
            startDate           : null,
            endDate             : null,
            dataPenagihan       : [],
            pageCount           : 0,
            currentPage         : 0,
            filter_status       : "",
            filter_tgl_dari     : "",
            filter_tgl_sampai   : "",
            isLoading           : true
        }

        this.handleChange                   = this.handleChange.bind(this)
        this.handleResetFilter              = this.handleResetFilter.bind(this)
        this.handlePageClick                = this.handlePageClick.bind(this)
        this.handleDatepickerStartChange    = this.handleDatepickerStartChange.bind(this)
        this.handleDatepickerEndChange      = this.handleDatepickerEndChange.bind(this)
    }

    handleChange(event) {

        const target = event.target;
        const value  = target.value;
        const name   = target.name;

        this.setState({
            [name]: value
        })        
    }

    loadData() {

        this.setState({ isLoading: true })
    
        const params = qs.stringify({
            status      : this.state.filter_status,
            tgl_dari    : this.state.filter_tgl_dari,
            tgl_sampai  : this.state.filter_tgl_sampai,
            tipe        : "rumah_sakit",
            page        : this.state.currentPage + 1,
        })

        axios({
            method: 'get',
            url: '/penagihan/getDataPenagihan?' + params
        })
        .then(response => {
            this.setState({
                dataPenagihan : response.data.data,
                pageCount     : response.data.last_page,
                isLoading     : false
            })
        })
        .catch(error => {

            console.log(error)
            
            this.setState({isLoading: false})

            Alert.error("Tidak dapat terhubung ke server");
        })
    }

    handleResetFilter() {
        this.setState({
            filter_status       : "",
            filter_tgl_dari     : "",
            filter_tgl_sampai   : "",
            startDate           : null,
            endDate             : null,
        })
    }

    handlePageClick(data) {

        let selected = data.selected; // zero based index

        this.setState({currentPage: selected}, () => {
            this.loadData();
        });
    }

    handleDatepickerStartChange(date) {
        this.setState({
            startDate       : date,
            filter_tgl_dari : date.format('YYYY-MM-DD')
        });
    }

    handleDatepickerEndChange(date) {
        this.setState({
            endDate             : date,
            filter_tgl_sampai   : date.format('YYYY-MM-DD')
        });
    }

    
    componentDidMount() {
        
        this.loadData()        
    }

    componentDidUpdate(nextProps, nextState) {
        
        if (this.state.filter_status !== nextState.filter_status ||
            this.state.filter_tgl_dari !== nextState.filter_tgl_dari ||
            this.state.filter_tgl_sampai !== nextState.filter_tgl_sampai ) {

            this.setState({pageCount: 0, currentPage: 0},() => {
                this.loadData()
            })
        }
    }    

    render () {
        
        const listData = this.state.dataPenagihan === null || this.state.dataPenagihan.length === 0 ? null : (

            this.state.dataPenagihan.map((item) => {
                return (
                    <tr key={item.id_penagihan}>
                        <td>{dateIndo(item.tgl_penagihan)}</td>
                        <td>{format({prefix: 'Rp ', integerSeparator: "."})(item.nominal_penagihan)}</td>
                        <td>
                            <span className="badge badge-info" style={{fontSize: "90%"}}>
                                {item.penagihan_status}
                            </span>
                        </td>
                        <td>{item.user_name}</td>
                    </tr>
                )
            })
        )

        return (

            <div className="col-sm-12">
                <CardSaldo />
                <div className="card">
                    <div className="card-block">
                        <NavLink
                            to={`${this.props.match.url}/add`}
                            className="btn btn-primary"
                        >
                            Request Penagihan Baru
                        </NavLink>
                    </div>
                </div>
                <div className="card">
                    <div className="card-header">
                        Data Penagihan
                    </div>
                    <div className="card-block">
                        <div style={{marginBottom: "30px"}}>
                            <div className="form-group row">
                                <div className="col-md-4">
                                    <label className="form-form-control-label text-muted">Filter Data</label>
                                </div>
                                <div className="col-md-6">
                                    <label className="form-form-control-label text-muted">Filter Tanggal Penagihan</label>
                                </div>
                                <div className="col-md-12"></div>
                                <div className="col-md-4">
                                    <FormDropdown
                                        name="filter_status"
                                        onChange={this.handleChange}
                                        value={this.state.filter_status}
                                        items={status_penagihan}
                                        placeholder="- Status Penagihan:" />
                                </div>
                                <div className="col-md-8">
                                    <div className="custom-react-datepicker">
                                        <DatePicker
                                            selected={this.state.startDate}
                                            selectsStart
                                            startDate={this.state.startDate}
                                            endDate={this.state.endDate}
                                            onChange={this.handleDatepickerStartChange}
                                            dateFormat="DD-MM-YYYY"
                                        />
                                        {" s/d "}
                                        <DatePicker
                                            selected={this.state.endDate}
                                            selectsEnd
                                            startDate={this.state.startDate}
                                            endDate={this.state.endDate}
                                            onChange={this.handleDatepickerEndChange}
                                            dateFormat="DD-MM-YYYY"
                                        />
                                    </div>
                                    {" "}
                                    <button
                                        className="btn btn-md btn-primary"
                                        onClick={this.handleResetFilter}
                                    >
                                        Reset Filter
                                    </button>
                                </div>
                            </div>
                        </div>
                        {
                            this.state.isLoading ? "Memuat Data..." : (
                                listData === null ? "Data Kosong..." : (
                                    <div>
                                        <table className="table table-striped animated fadeIn">
                                            <thead>
                                                <tr>
                                                    <th>Tanggal Penagihan</th>
                                                    <th>Nominal Penagihan</th>
                                                    <th>Status Penagihan</th>
                                                    <th>Request Oleh</th>
                                                </tr>
                                            </thead>
                                            <tbody>{listData}</tbody>
                                        </table>

                                        <Paging 
                                            handlePageClick={this.handlePageClick}
                                            pageCount={this.state.pageCount}
                                            currentPage={this.state.currentPage}
                                        />
                                    </div>
                                )
                            )
                        }
                    </div>
                </div>
            </div>

        )
    }
}

export default Lists;



// WEBPACK FOOTER //
// ./src/views/Penagihan/Lists.js